import React, { Component } from 'react';
import Category from './helpers/Category';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { withRouter } from 'react-router-dom';

class MyDashboard extends Component {
  state = {
    currentPatient: this.props.currentPatient,
  };
  lgHeader = {
    id: 'lgHeader',
    src: require('./images/mydashboard/txt_lg_MyDashboard.png'),
    width: 732,
    height: 35,
    left: 0,
  };
  smHeader = {
    id: 'smHeader',
    src: require('./images/mydashboard/txt_sm_MyDashboard.png'),
    width: 222,
    height: 222,
  };
  cat1Buttons = [
    {
      id: 'eduVideos',
      to: '/assigned_education',
      highlight: require('./images/mydashboard/txt_WatchEduVideos_HL.png'),
      unhighlight: require('./images/mydashboard/txt_WatchEduVideos_UH.png'),
      alt: 'Watch Education',
    },
    {
      id: 'dwb',
      to: '/DWB',
      highlight: require('./images/mydashboard/txt_Digital_Whiteboard_HL.png'),
      unhighlight: require('./images/mydashboard/txt_Digital_Whiteboard_UH.png'),
      alt: 'Digital Whiteboard',
    },
    {
      id: 'orderMeals',
      to: '/room_service',
      highlight: require('./images/mydashboard/txt_OrderMeals_HL.png'),
      unhighlight: require('./images/mydashboard/txt_OrderMeals_UH.png'),
      alt: 'Order Meals',
    },
    {
      id: 'viewSchedule',
      to: '/scheduled_procedures',
      highlight: require('./images/mydashboard/txt_ViewSchedule_HL_' +
        this.props.currentPatient +
        '.png'),
      unhighlight: require('./images/mydashboard/txt_ViewSchedule_UH_' +
        this.props.currentPatient +
        '.png'),
      alt: 'View Schedule',
    },
    {
      id: 'fallPrecaution',
      to: '/main_menu/mydashboard/fallPrecaution',
      highlight: require('./images/mydashboard/txt_FallPrecaution_HL.png'),
      unhighlight: require('./images/mydashboard/txt_FallPrecaution_UH.png'),
      alt: 'Fall Precaution',
    },
    {
      id: 'resumeMovie',
      to: '/movies/categories/action/action/main_menu',
      highlight: require('./images/mydashboard/txt_ResumeMovie_HL.png'),
      unhighlight: require('./images/mydashboard/txt_ResumeMovie_UH.png'),
      alt: 'Resume Movie',
    },
    {
      id: 'watchTv',
      to: '/ipg',
      highlight: require('./images/mydashboard/txt_WatchTV_HL.png'),
      unhighlight: require('./images/mydashboard/txt_WatchTV_UH.png'),
      alt: 'Watch TV',
    },
    {
      id: 'environmentalControls',
      to: '/environmental_controls',
      highlight: require('./images/stay/txt_RoomControls_HL.png'),
      unhighlight: require('./images/stay/txt_RoomControls_UH.png'),
      alt: 'Room Temperature',
    },
  ];

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPatient !== this.props.currentPatient) {
      this.setState({
        currentPatient: this.props.currentPatient,
      });
      this.cat1Buttons = [
        {
          id: 'eduVideos',
          to: '/assigned_education',
          highlight: require('./images/mydashboard/txt_WatchEduVideos_HL.png'),
          unhighlight: require('./images/mydashboard/txt_WatchEduVideos_UH.png'),
          alt: 'Watch Education',
        },
        {
          id: 'orderMeals',
          to: '/room_service',
          highlight: require('./images/mydashboard/txt_OrderMeals_HL.png'),
          unhighlight: require('./images/mydashboard/txt_OrderMeals_UH.png'),
          alt: 'Order Meals',
        },
        {
          id: 'viewSchedule',
          to: '/scheduled_procedures',
          highlight: require('./images/mydashboard/txt_ViewSchedule_HL_' +
            this.props.currentPatient +
            '.png'),
          unhighlight: require('./images/mydashboard/txt_ViewSchedule_UH_' +
            this.props.currentPatient +
            '.png'),
          alt: 'View Schedule',
        },
        {
          id: 'fallPrecaution',
          to: '/main_menu/mydashboard/fallPrecaution',
          highlight: require('./images/mydashboard/txt_FallPrecaution_HL.png'),
          unhighlight: require('./images/mydashboard/txt_FallPrecaution_UH.png'),
          alt: 'Fall Precaution',
        },
        {
          id: 'resumeMovie',
          to: '/movies/categories/action/action/main_menu',
          highlight: require('./images/mydashboard/txt_ResumeMovie_HL.png'),
          unhighlight: require('./images/mydashboard/txt_ResumeMovie_UH.png'),
          alt: 'Resume Movie',
        },
        {
          id: 'watchTv',
          to: '/ipg',
          highlight: require('./images/mydashboard/txt_WatchTV_HL.png'),
          unhighlight: require('./images/mydashboard/txt_WatchTV_UH.png'),
          alt: 'Watch TV',
        },
        {
          id: 'language',
          to: '/languages',
          highlight: require('./images/stay/txt_Language_HL.png'),
          unhighlight: require('./images/stay/txt_Language_UH.png'),
          alt: 'Language',
        },
      ];
    } else {
      return null;
    }
  }

  render() {
    const currentHighlight =
      this.props.current === this.props.movingPos && this.props.current === 0;
    const shrinkMe = this.props.current === 0 && this.props.movingPos === -1;
    const growMe = this.props.current === -1 && this.props.movingPos === 0;

    return (
      <Category
        largeHeader={this.lgHeader}
        smallHeader={this.smHeader}
        serviceLinks={this.cat1Buttons}
        shrinkGrow={this.props.shrinkGrow}
        hlState={this.props.hlState}
        movedir={this.props.movedir}
        currentHighlight={currentHighlight}
        shrinkMe={shrinkMe}
        growMe={growMe}
        disabled={this.props.disabled}
      />
    );
  }
}

const ConnectedMyDashboard = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(MyDashboard);

export default withRouter(ConnectedMyDashboard);
